import { api } from "@/lib/http";
import type { Note } from "@/types/api";

export const notesApi = {
  list: () => api.get<Note[]>("/api/notes"),
  create: (text: string) => api.post<Note>("/api/notes", { text }),
  remove: (id: number) => api.del<void>(`/api/notes/${id}`),
};
